import { FC } from 'react';
import { PropagateLoader } from 'react-spinners';
import {
  Bar,
  CartesianGrid,
  ComposedChart,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import theme from '../../../styles/themes/default';
import { Container } from './styles';

interface IProps {
  title: string;
  data: any;
  barColor?: string;
  lineColor?: string;
  isLoading: boolean;
  isFetching: boolean;
  error: any;
}

const ComposeBarLineChart: FC<IProps> = ({
  title,
  data,
  barColor,
  lineColor,
  isLoading,
  isFetching,
  error,
}) => {
  return (
    <Container>
      {(isLoading || isFetching) && <h3>Carregando...</h3>}
      {error! && <h3>Falha ao carregar dados.</h3>}

      {(!isLoading || !isFetching) && data && data?.length > 0 && (
        <h3>{title}</h3>
      )}

      {!isLoading && !isFetching && (!data || data?.length === 0) && (
        <h3>'Não encontramos dados para sua pesquisa.'</h3>
      )}
      <ResponsiveContainer
        width="100%"
        height="100%"
        key={Math.floor(Math.random() * 45)}
      >
        {!isLoading && !isFetching ? (
          <ComposedChart
            data={data}
            margin={{
              top: 20,
              right: 20,
              bottom: 20,
              left: 20,
            }}
          >
            <CartesianGrid stroke={theme.colors.gray[200]} />

            <XAxis
              dataKey="uf"
              style={{
                fontSize: '16px',
                fontWeight: 800,
                color: theme.colors.gray[600],
              }}
            />

            <YAxis yAxisId="left" style={{ stroke: 'none' }} />
            <YAxis
              yAxisId="right"
              orientation="right"
              style={{ stroke: 'none' }}
            />

            <Tooltip
              formatter={(value, name, props) => [
                name === 'Débitos'
                  ? ` R$ ${value.toLocaleString('pt-BR', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}`
                  : value,
                name,
              ]}
            />

            <Bar
              yAxisId="left"
              dataKey="Veículos"
              barSize={20}
              fill={barColor || '#413ea0'}
            />
            <Line
              yAxisId="right"
              dataKey="Débitos"
              stroke={lineColor || '#ff7300'}
              strokeWidth={2}
            />
          </ComposedChart>
        ) : (
          <aside>
            <PropagateLoader size={20} />
          </aside>
        )}
      </ResponsiveContainer>
    </Container>
  );
};

export default ComposeBarLineChart;
